export const safeJsonParse = (value, fallback) => {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

export const storageGetJson = (key, fallback) => {
  if (!key || typeof window === "undefined") return fallback;
  const raw = window.localStorage.getItem(key);
  return safeJsonParse(raw, fallback);
};

export const storageSetJson = (key, value) => {
  if (!key || typeof window === "undefined") return;
  window.localStorage.setItem(key, JSON.stringify(value));
};

export const storageGetString = (key, fallback = null) => {
  if (!key || typeof window === "undefined") return fallback;
  const raw = window.localStorage.getItem(key);
  return typeof raw === "string" ? raw : fallback;
};

export const storageSetString = (key, value) => {
  if (!key || typeof window === "undefined") return;
  window.localStorage.setItem(key, String(value));
};

export const storageRemove = (key) => {
  if (!key || typeof window === "undefined") return;
  window.localStorage.removeItem(key);
};
